<template>
  <Head title="Agency Settings" />
  
  <AppLayout>
    <div class="container-fluid">
      <div class="row justify-content-center mx-4">
        <div class="col p-0"> 
          <agency-settings :agency="agency" :user="auth.user" :agency-clients="agencyClients"></agency-settings>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';
import AppLayout from '../../Layouts/AppLayout.vue';

defineProps({
  agency: Object,
  auth: Object,
  agencyClients: Array
});
</script>

